export enum CouponStatus {
  /**
   * 未使用
   */
  UnUsed = 1,
  /**
   * 已使用
   */
  Used,
  /**
   * 已过期
   */
  Expired,
}

/**
 * 优惠券类型
 */
export enum CouponType {
  /**
   * 电商券，（欧洲当前只有电商券）
   */
  ECommerce = 1,
  // /**
  //  * 利息券
  //  */
  // Interest,
  /**
   * 分期券
   */
  Installment = 3,
  /**
   * 分期券
   */
  Installment2 = 4,
  // /**
  //  * Opanpay电商券
  //  */
  // OpanpayECommerce,
  // /**
  //  * Opanpay利息券
  //  */
  // OpanpayInterest,
  // /**
  //  * Opanpay分期券
  //  */
  // OpanpayInstallment,
  /**
   * 店铺券
   */
  Shop = 8,
  /**
   * 商品券
   */
  Product = 9,
  // /**
  //  * pid 借款折扣券
  //  */
  // PidLoanDiscount = 13,
  // /**
  //  * pid 借款减免券
  //  */
  // PidLoanRelief,
  // /**
  //  * pid 还款减免券
  //  */
  // PidRepayRelief,
}

/**
 * 优惠券有效时间类型 1:开始/结束时间 2:固定时长
 */
export enum TimeLimitType {
  /**
   * 时间段
   */
  Period = 1,
  /**
   * 固定时长
   */
  Fixed,
}

/**
 * 优惠券优惠类型 1:满减券 2:满折券
 */
export enum DiscountType {
  /**
   * 满减券
   */
  FullReduction = 1,
  /**
   * 满折券
   */
  FullDiscount,
}

export interface CouponItemModel {
  /**
   * 优惠券id
   */
  couponId: number | string;
  /**
   * 优惠券模板id
   */
  couponTemplateId: number | string;
  /**
   * 优惠券名称
   */
  name: string;
  /**
   * 优惠券类型 1:电商券 3:利息券 4:分期券 5:openpay电商券 6:openpay利息券 7:openpay分期券 8:店铺券 9:商品券 13:pid借款折扣券 14:pid借款减免券 15:pid还款减免券
   */
  couponType: CouponType;
  /**
   * 优惠券运营主体 AKU/AFI
   */
  businessSideId?: string;
  /**
   * 面额 满减券为优惠券面额 范围1-999999999 满折券为折扣率 范围0-100
   */
  faceAmount: number | string;
  /**
   * 金额币种
   */
  currency: string;
  /**
   * 优惠券优惠类型 1:满减券 2:满折券
   */
  discountType: DiscountType;
  /**
   * 优惠券有效时间类型 1:开始/结束时间 2:固定时长
   */
  timeLimitType?: TimeLimitType;
  /**
   * 使用门槛金额 电商券为订单金额
   */
  thresholdAmount: number | string;
  /**
   * 分期本金门槛
   */
  installThresholdAmount?: number | string;
  /**
   * 优惠券生效开始时间
   */
  startTime: string;
  /**
   * 优惠券生效结束时间
   */
  endTime: string;
  /**
   * 剩余过期天数
   */
  expireDay?: number;
  /**
   * 优惠券描述
   */
  description: string;
  /**
   * 是否仅限分期使用
   */
  isOnlyInstallmentUsed: boolean;
  /**
   * 优惠券折扣描述
   */
  discountDesc?: string;
  /**
   * 优惠券门槛描述
   */
  thresholdDesc?: string;
  /**
   * 可支持分期数
   */
  supportPeriodLmt?: undefined;
  /**
   * 是否和活动互斥
   */
  isExclusiveWithPromotion: boolean;
  /**
   * 是否是全品类券
   */
  isUniversal?: boolean;
  /**
   * 跳转链接【只有金融券有】
   */
  jumpLink?: string;
  /**
   * 是否快过期 true-是 false-不是
   */
  expiredRecently?: boolean;
  /**
   * CDK兑换码
   */
  couponCdk?: string;
  /**
   * 是否支持线下扫码
   */
  isOfflineScanCode?: boolean;
  /**
   * 门槛上限金额
   */
  limitAmount?: number | string;
  /**
   * 满折券最大优惠金额
   */
  discountLimitAmount: number | string;
  /**
   * 店铺id(仅店铺券和商品券)
   */
  shopId: number | string;
  /**
   * 店铺logo(仅店铺券和商品券)
   */
  shopLogo: string;
  /**
   * 不可用/不可选原因
   */
  unAvailableReason: string;
  /**
   * 优惠券优惠金额
   */
  discount?: string;
  /**
   * 优惠券生效结束时间
   */
  endDate?: string;
  startDate?: string;
  id: number | string;
  /**
   * 是否可用
   */
  isAvailable?: boolean;
  /**
   * 是否可选
   */
  isSelectable?: boolean;
  /**
   * 是否已选
   */
  isSelected?: boolean;
  /**
   * 优惠券剩余有效时间
   */
  remainingValidTime?: number;
  /**
   * 优惠券模板ID
   */
  templateId?: number | string;
}

export interface CouponListResponse {
  pageNo: number;
  pageSize: number;
  records: CouponItemModel[];
  totalRecords: number;
  isLast: number;
}
